export default {
	init() {
		$('.afbeeldingen').slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			speed: 300,
			infinite: true,
			arrows: false,
			dots: true,
		});
		$('.afbeeldingen').slickLightbox({
			navigateByKeyboard: true,
		});
		window.onscroll = function() {
			myFunction()
		};
		var header = document.getElementById("mainMenuBar");
		var sticky = header.offsetTop;
		
		function myFunction() {
			if (window.pageYOffset > sticky) {
				header.classList.add("stickyHeader");
			} else {
				header.classList.remove("stickyHeader");
			}
		}
		
		$('#showSearch').click(function() {
			$('.mobileSearch').toggle(0);
		});
		$(document).scroll(function () {
			var y = $(this).scrollTop();
			if (y > 280) {
				$('.menuStick').slideDown();
			} else {
				$('.menuStick').slideUp(0);
			}
		});
	},
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js